module.exports = __webpack_public_path__ + "4f0283c6ce28e888000e978e537a6a56.png";


//////////////////
// WEBPACK FOOTER
// ./~/leaflet/dist/images/layers-2x.png
// module id = 792
// module chunks = 0